function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import { ButtonTertiary } from "../";
import "./FinderTabs.scss";

class FinderTabs extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      index: 0,
      tabs: [],
      tabpanels: []
    });

    _defineProperty(this, "componentDidUpdate", prevProps => {
      if (prevProps.tabIndex !== this.props.tabIndex) {
        this.getTabs();
      }

      if (prevProps.tabId !== this.props.tabId) {
        this.getTabs();
      }

      if (prevProps.children !== this.props.children) {
        this.getTabs();
      }
    });

    _defineProperty(this, "getTabpanel", (child, index) => {
      const _child$props = child.props,
            id = _child$props.id,
            url = _child$props.url,
            title = _child$props.title,
            children = _child$props.children;
      const tabpanelId = id || "admin-tabs-" + index;
      const tabId = tabpanelId + "-tab";
      return {
        index: index,
        id: tabpanelId,
        labelledby: tabId,
        children: children
      };
    });

    _defineProperty(this, "getTab", (child, index) => {
      const _child$props2 = child.props,
            id = _child$props2.id,
            url = _child$props2.url,
            title = _child$props2.title,
            children = _child$props2.children;
      const tabpanelId = id || "admin-tabs-" + index;
      const tabId = tabpanelId + "-tab";
      return {
        index: index,
        url: url,
        id: tabId,
        controls: tabpanelId,
        title: title
      };
    });

    _defineProperty(this, "getTabs", () => {
      const _this$props = this.props,
            tabIndex = _this$props.tabIndex,
            tabId = _this$props.tabId;

      if (!this.props.children) {
        return false;
      }

      const tabs = React.Children.toArray(this.props.children).map(this.getTab);
      const tabpanels = React.Children.toArray(this.props.children).map(this.getTabpanel);
      let tabsById = {};
      tabpanels.map(tab => {
        tabsById[tab.id] = tab;
      });

      if (!tabsById) {
        return false;
      } // set index by tabId or tabIndex


      const index = tabId && tabsById && tabsById[tabId] && tabsById[tabId].index || tabIndex;
      this.setState({
        index: index,
        tabs: tabs,
        tabpanels: tabpanels
      });
    });

    _defineProperty(this, "renderTabpanel", (tabpanel, index) => {
      const id = tabpanel.id,
            labelledby = tabpanel.labelledby,
            children = tabpanel.children;
      const selected = this.state.index === index;
      return React.createElement("div", {
        className: "admin-finder__tabpanel",
        role: "tabpanel",
        id: id,
        "aria-selected": selected,
        "aria-labelledby": labelledby,
        key: id
      }, children);
    });

    _defineProperty(this, "renderTab", (tab, index) => {
      const id = tab.id,
            controls = tab.controls,
            url = tab.url,
            title = tab.title;
      const selected = this.state.index === index;
      return React.createElement(ButtonTertiary, {
        key: id,
        title: title,
        url: url,
        id: id,
        controls: controls,
        role: "tab",
        selected: selected,
        onClick: event => this.onSelect(tab, event)
      });
    });

    _defineProperty(this, "onSelect", (tab, event) => {
      const id = tab.id,
            index = tab.index;
      this.setState({
        index: index,
        id: id
      });

      if (this.props.onSelect) {
        this.props.onSelect(tab, event);
      }
    });
  }

  componentDidMount() {
    this.getTabs();
  }

  render() {
    const _this$state = this.state,
          tabs = _this$state.tabs,
          tabpanels = _this$state.tabpanels;
    return React.createElement("div", {
      className: "admin-finder__tabs",
      role: "dialog"
    }, React.createElement("nav", {
      className: "nav-tabs"
    }, tabs.map(this.renderTab)), tabpanels.map(this.renderTabpanel));
  }

}

_defineProperty(FinderTabs, "defaultProps", {
  tabIndex: 0,
  tabId: undefined
});

export default FinderTabs;